import { Autocomplete, TextField } from '@mui/material';

interface PrimaryTagsInputProps {
  label?: string;
  placeholder?: string;
  value: string[];
  onChange: (value: string[]) => void;
}

const commitPendingInput = (
  inputValue: string,
  value: string[],
  onChange: (value: string[]) => void,
) => {
  const tag = inputValue.trim();
  if (tag && !value.includes(tag)) {
    onChange([...value, tag]);
  }
};

const PrimaryTagsInput = ({
  label, placeholder, value, onChange,
}: PrimaryTagsInputProps) => (
  <Autocomplete
    multiple
    freeSolo
    size="small"
    options={[]}
    value={value}
    onChange={(_event, newValue) => onChange(newValue as string[])}
    onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === ',') {
        event.preventDefault();
        const input = event.target as HTMLInputElement;
        commitPendingInput(input.value, value, onChange);
        input.value = '';
      }
    }}
    onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
      commitPendingInput(event.target.value ?? '', value, onChange);
    }}
    renderInput={(params) => (
      <TextField {...params} label={label} placeholder={placeholder} />
    )}
  />
);

PrimaryTagsInput.defaultProps = {
  label: '',
  placeholder: '',
};

export default PrimaryTagsInput;
